import { removeKeysFromQueryId } from 'ducks/searches/utils/query'

export const toPinnedSearchQueryId = queryId => {
  return removeKeysFromQueryId(
    ['orderBy', 'cursor', 'type', 'channel'],
    queryId
  )
}
